export function readViewerConfig() {
  const params = new URLSearchParams(window.location.search)
  const fragmentParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))

  return {
    taskId: String(params.get('taskId') || '').trim(),
    fallbackTitle: String(params.get('title') || 'MeTop.ai 3D 空间').trim(),
    fallbackImageUrl: String(params.get('imageUrl') || '').trim(),
    requestedFormat: String(params.get('format') || '').trim(),
    pipelineHint: String(params.get('pipeline') || '').trim(),
    activity: String(params.get('activity') || '').trim(),
    shareId: String(params.get('shareId') || '').trim(),
    debugPanel: String(params.get('panel') || '').trim(),
    debugUi: params.get('debugUi') === '1',
    testModelUrl: import.meta.env.DEV ? String(params.get('testModel') || '').trim() : '',
    viewMode: String(params.get('view') || '').trim(),
    entrySource: String(params.get('entry') || '').trim(),
    embedded: params.get('embedded') === '1',
    channel: String(params.get('channel') || (params.get('embedded') === '1' ? 'miniapp' : 'web')).trim(),
    miniappClientId: String(params.get('clientId') || '').trim(),
    videoSubscribeEnabled: params.get('videoSubscribeEnabled') === '1',
    sharedEntry: params.get('shared') === '1',
    apiBase: String(params.get('apiBase') || import.meta.env.VITE_API_BASE_URL || 'https://nj.metop.com.cn/backend').trim(),
    authToken: String(fragmentParams.get('token') || params.get('token') || '').trim()
  }
}
